import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import "@maplibre/maplibre-gl-leaflet";

// O worker vem de um arquivo próprio (copiado pelo scripts/copy-maplibre-worker.js)
// em vez do blob que o maplibre monta a partir do próprio código: a minificação
// do build de produção quebra esse blob.
maplibregl.setWorkerUrl(`${process.env.PUBLIC_URL}/maplibre-gl-csp-worker.js`);

// Base do mapa servida pelo OpenFreeMap (tiles vetoriais, sem token).
// Substitui o raster do Mapbox, cujo token foi revogado.
export const OPENFREEMAP_STYLE = "https://tiles.openfreemap.org/styles/positron";

export const OPENFREEMAP_ATTRIBUTION =
  '&copy; <a href="https://openfreemap.org">OpenFreeMap</a> &copy; <a href="https://www.openmaptiles.org/">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';

function VectorTileLayer({ style = OPENFREEMAP_STYLE }) {
  const map = useMap();

  useEffect(() => {
    const layer = L.maplibreGL({
      style,
      attribution: OPENFREEMAP_ATTRIBUTION,
    });
    layer.addTo(map);

    return () => {
      map.removeLayer(layer);
    };
  }, [map, style]);

  return null;
}

export default VectorTileLayer;
